import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { RippleModule } from 'primeng/ripple';
import { TooltipModule } from 'primeng/tooltip';

import { SidebarIconComponent } from './sidebar-icon.component';

@Component({
  selector: 'app-sidebar-user-panel',
  standalone: true,
  imports: [AvatarModule, RippleModule, TooltipModule, SidebarIconComponent],
  templateUrl: './sidebar-user-panel.component.html',
  styleUrls: ['./sidebar-user-panel.component.scss'],
})
export class SidebarUserPanelComponent {
  @Input({ required: true }) collapsed = false;
  @Input({ required: true }) username = '';
  @Input({ required: true }) userRole = '';
  @Input({ required: true }) userInitials = '';
  @Input({ required: true }) backendVersion = '';
  @Input({ required: true }) backendVersionLoading = false;
  @Input({ required: true }) backendVersionError: string | null = null;
  @Input({ required: true }) logoutInProgress = false;
  @Input({ required: true }) logoutError: string | null = null;

  @Output() logoutRequested = new EventEmitter<void>();

  readonly currentYear = new Date().getFullYear();

  get collapsedLogoutTooltip(): string {
    if (this.logoutInProgress) {
      return 'Trwa wylogowywanie...';
    }

    return this.username ? `Wyloguj się: ${this.username}` : 'Wyloguj się';
  }
}
